import Utils from "../utils";

/**
 * Sesión simulada para desarrollo sin backend.
 *
 * Se prende y se apaga desde el toggle que aparece abajo a la izquierda cuando
 * el sitio corre con `gatsby develop` (ver `src/components/FakeAuthToggle.jsx`).
 * El estado vive en local storage, así sobrevive a los recargos, y al prenderlo
 * se escribe `userProfileData` igual que lo haría un login real, que es lo que
 * habilita la lista de precios.
 *
 * En producción `IS_LOCAL_DEV` es `false`: el toggle no se monta y el contexto
 * nunca nace con la sesión falsa.
 */
export const IS_LOCAL_DEV = process.env.NODE_ENV === "development";

const FAKE_AUTH_KEY = "fakeAuth";

export const FAKE_AUTH_STATE = {
	user: "usuario-demo",
	accessToken: "fake-access-token"
};

/** Perfil mínimo con la misma forma y compresión que guarda `LoginForm`. */
const FAKE_PROFILE_DATA = {
	user_name: FAKE_AUTH_STATE.user,
	display_name: "Usuario Demo",
	price_list: "demo"
};

export const isFakeAuthEnabled = () => {
	if (!IS_LOCAL_DEV || typeof window === "undefined") return false;
	return window.localStorage.getItem(FAKE_AUTH_KEY) === "true";
};

/** Deja el local storage como lo dejaría un login real. */
export const enableFakeAuth = () => {
	if (!IS_LOCAL_DEV || typeof window === "undefined") return;

	window.localStorage.setItem(FAKE_AUTH_KEY, "true");
	window.localStorage.setItem(
		"userProfileData",
		Utils.compressString(JSON.stringify(FAKE_PROFILE_DATA))
	);
};

/** Vuelve al estado público, igual que `useLogout` pero sin llamar al servidor. */
export const disableFakeAuth = () => {
	if (typeof window === "undefined") return;

	window.localStorage.removeItem(FAKE_AUTH_KEY);
	window.localStorage.removeItem("userProfileData");
};
